var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "SGM" },
    _vm._l(_vm.sgpEvents, function(eventId) {
      return _c(
        "div",
        [
          _c("sgp", {
            attrs: {
              tab: _vm.tab,
              eventId: eventId,
              currentBetSlipState: _vm.currentBetSlipState,
              allowedBetTypesAndReturn:
                _vm.allowedBetTypesAndReturnsXP.PerEvent[eventId],
              allowedBetTypesAndReturns: _vm.allowedBetTypesAndReturns,
              gettingABTnR: _vm.gettingABTnR
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc1c22fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc1c22fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/SGM/SGM.vue
// module id = null
// module chunks = 